import React, { useEffect, useMemo, useState } from "react";
import { InputNumberPadrao, LabelPadrao, ModalPadrao, MoneyIcon } from "../../components/Base";
import { Radio, Space, Tag, Tooltip } from "antd";
import { BtnPadrao, BtnSair } from "../../components/Buttons";
import roundCustom from "../../Utils/RoundCustom";
import Porcentagem from "../../Utils/Porcentagem";
import culture from "../../Utils/Culture";
import { MdBrightnessAuto } from "react-icons/md";

export default function ModalDescontoPromocao({ produto, onOk, onCancel, formatarPrdPromo }) {
  const [produtoInterno, setProdutoInterno] = useState(null);
  const [descontoPromocao, setDescontoPromocao] = useState(null);

  const qtdInvalidaTxt = useMemo(() => {
    if (!produto || !descontoPromocao?.valor)
      return null;

    if (descontoPromocao.qtdMinima > produto.qtd)
      return `A quantidade mínima para o Desconto/Promoção selecionado é de ${descontoPromocao.qtdMinima} itens`;
    else if (descontoPromocao.qtdMaxima < produto.qtd)
      return `A quantidade máxima para o Desconto/Promoção selecionado é de ${descontoPromocao.qtdMaxima} itens`;
    else
      return null;

  }, [descontoPromocao]);

  const valor = useMemo(() => {
    if (!produto?.preco)
      return 0;

    let valor = produto.preco;

    if (descontoPromocao?.tipo == 'DescontoPorcentagem' || descontoPromocao?.tipo == 'Tabela')
      valor = `R$ ${culture.format(roundCustom(produto.preco - Porcentagem.calcular(descontoPromocao.valor, produto.preco)))}`;
    else if (descontoPromocao?.tipo == 'ValorFixo' || descontoPromocao?.tipo == 'DescontoFixo' || descontoPromocao?.tipo == 'TabelaValorFixo')
      valor = `R$ ${culture.format(produto.preco - descontoPromocao.valor)}`;
    else if (descontoPromocao?.tipo == 'Quantidade')
      valor = `Min: ${descontoPromocao.qtdMinima} - Máx: ${descontoPromocao.qtdMaxima}`;

    return valor;
  }, [produto, descontoPromocao]);

  useEffect(() => {
    if (!!produto) {
      setProdutoInterno({ ...produto });
      if (!!produto.descontoPromocao)
        setDescontoPromocao({ ...produto.descontoPromocao });
    }
    else {
      setProdutoInterno(null);
      setDescontoPromocao(null);
    }

  }, [produto]);

  return <ModalPadrao title="Desconto x Promoção" width={700} visible={!!produto} onCancel={() => { setProdutoInterno(null); onCancel(); }} footer={<div style={{ display: "flex", justifyContent: "space-between" }}>
    <BtnPadrao style={{ visibility: !!produto?.descontoPromocao ? "visible" : "hidden" }} onClick={() => { onOk({}); setProdutoInterno(null); }}>Desvincular</BtnPadrao>
    <div>
      <BtnPadrao disabled={descontoPromocao == null || !!qtdInvalidaTxt} onClick={() => { onOk(descontoPromocao); setProdutoInterno(null); }}>Confirmar</BtnPadrao>
      <BtnSair onClick={() => { setProdutoInterno(null); onCancel(); }} />
    </div>
  </ div>}>

    <Radio.Group style={{ width: "100%" }} onChange={v => setDescontoPromocao(produto.promocoes.find(x => x.id == v.target.value))} value={descontoPromocao?.id}>
      <Space direction="vertical" style={{ width: "100%" }}>
        {produtoInterno?.promocoes?.map(x => <Radio key={x.id} value={x.id} style={{ position: "relative", width: "100%" }}>
          <div style={{ display: "flex" }}>
            <span>{x.descricao}</span>

            <Tooltip title={x.todasModalidades ? "Todas modalidades" : <>
              <LabelPadrao noMargin style={{ textAlign: "center" }}>Modalidades</LabelPadrao>
              {x.modalidades?.map(s => <p style={{ margin: 0, padding: 0 }} key={s.id}>{s.nome}</p>)}
            </>} placement="right">
              <MoneyIcon className="row-verde cad-icon-small" style={{ margin: "0 5px" }} size={20} />
            </Tooltip>

            {x.isAplicadoAutomatico && <Tooltip title="Aplicado automático" placement="right">
              <MdBrightnessAuto className="row-amarelo" size={20} />
            </Tooltip>}

            {x.tipo != "Quantidade" ? <Tooltip title="Valor ao aplicar" placement="right">
              <span style={{ position: "absolute", right: 0 }}>R$ {culture.format(formatarPrdPromo(produto.qtd, { ...produto }, x).valorTotal)}</span>
            </Tooltip> : <span style={{ position: "absolute", right: 0 }}>Compre {culture.format(x.qtdMinima)} leve {culture.format(x.valor)}</span>}
          </div>
        </Radio>)}
      </Space>
    </Radio.Group>

    <div style={{ display: "flex" }}>
      <div style={{ marginRight: 10, width: "50%" }}>
        {descontoPromocao?.tipo == 'DescontoFixo' && <LabelPadrao>Desconto R$</LabelPadrao>}
        {(descontoPromocao?.tipo == 'DescontoPorcentagem' || descontoPromocao?.tipo == 'Tabela') && <LabelPadrao>Desconto %</LabelPadrao>}
        {descontoPromocao?.tipo == 'Quantidade' && <LabelPadrao>Quantidade extra</LabelPadrao>}
        <InputNumberPadrao
          style={{ width: "100%", visibility: (!descontoPromocao || descontoPromocao?.tipo == 'ValorFixo' || descontoPromocao?.tipo == 'TabelaValorFixo') ? "hidden" : undefined }}
          precision={descontoPromocao?.tipo == 'Quantidade' ? 0 : 2}
          value={descontoPromocao?.valor}
          onChange={v => setDescontoPromocao({ ...descontoPromocao, valor: v })}
          min={0}
          max={descontoPromocao?.maximoNegociavel || produto?.promocoes.find(x => x.id == descontoPromocao?.id)?.valor}
          disabled={!descontoPromocao || !!qtdInvalidaTxt} />
      </div>
      <div style={{ width: "50%" }}>
        {(descontoPromocao?.tipo == 'ValorFixo' || descontoPromocao?.tipo == 'TabelaValorFixo') && <LabelPadrao>Desconto R$</LabelPadrao>}
        {(descontoPromocao?.tipo == 'DescontoFixo' || descontoPromocao?.tipo == 'DescontoPorcentagem' || descontoPromocao?.tipo == 'Tabela') && <LabelPadrao>Valor unitário R$</LabelPadrao>}
        {descontoPromocao?.tipo == 'Quantidade' && <LabelPadrao>&nbsp;</LabelPadrao>}
        {!descontoPromocao?.tipo && <LabelPadrao>Valor R$</LabelPadrao>}
        <InputNumberPadrao style={{ width: "100%" }} value={valor} disabled />
      </div>
    </div>
    <LabelPadrao style={{ visibility: (!!descontoPromocao?.maximoNegociavel && descontoPromocao?.tipo != 'ValorFixo' && descontoPromocao?.tipo != 'TabelaValorFixo') ? "visible" : "hidden" }}>Máximo negociável: {culture.format(descontoPromocao?.maximoNegociavel)}</LabelPadrao>
    {!!qtdInvalidaTxt && <Tag style={{ width: "100%", marginTop: 10 }} color="red">{qtdInvalidaTxt}</Tag>}
  </ModalPadrao>;
}